<template>
	<div class="providerRegister">
		<div class="banner">
			<img src="static/img/provider-bg.png">
		</div>
		<h3>登录</h3>
		<div class="content">
			<div class="input">
				<span>手机号</span>
				<input type="text" autocomplete="off" v-model="loginName" placeholder="请输入手机号码" />
			</div>
			<div class="input">
				<span>密码</span>
				<input type="password" autocomplete='new-password' v-model="loginPwd" placeholder="请输入密码" />
			</div>
			<button class="btn-blue" @click="providerLogin">登录</button>
			<p class="tologin"><a :href="'/reginalAgent/providerRegister?providerCode='+providerCode">返回注册</a></p>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'providerLogin',
		data() {
			return {
				providerCode: this.$route.query.providerCode,
				loginName: '',
				loginPwd: '',
				tjk_login_token: ''
			}
		},
		mounted() {

		},
		methods: {
			//合伙人登录
			providerLogin() {
				if(this.loginName == '') {
					this.$message({
						message: '请填写手机号码',
						type: 'error',
						center: true,
						duration: 3000
					})
					return
				}
				if(this.loginPwd == '') {
					this.$message({
						message: '请输入密码',
						type: 'error',
						center: true,
						duration: 3000
					})
					return
				}
				var data = {
				  teamCode: '000',
					loginName: this.loginName,
					loginPwd: this.loginPwd,
					deviceType: 'PC'
				}
				this.$http.post(API_ROOT.tjuser + '/tjkLogin/provider/login', data).then(response=> {
					var result = response.data
					if(result.success) {
						this.tjk_login_token = result.data
						window.location.href = '/reginalAgent/providerHasLogin?token='+this.tjk_login_token+'&phone='+this.loginName+'&providerCode='+this.providerCode
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						})
					}
				},response=> {
					this.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					})
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// providerLogin.vue?08d1f40c